import { COMMON_STATE } from '@/api/resources/entityState/common-state'
import { EntityState } from '@/api/resources/entityState/entity-state'
import { commonStatusService } from '@/api/services/common/status/common-status.service'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { keyBy, merge } from 'lodash'
import { store } from '@/store/store'

export const PORTION_STATES = {
    DRAFT: { code: 'DRAFT', class: 'state-draft', order: 10 },
    REGISTERED: { code: 'REGISTERED', class: 'state-primary', order: 20 },
    VERIFIED: { code: 'VERIFIED', class: 'state-alt-success-1', order: 30 },
    INSERTED: { code: 'INSERTED', class: 'state-process-5', order: 40 },
    PROCESSED: { code: 'PROCESSED', class: 'state-process-6', order: 50 },
    MADE_BLOCK: { code: 'MADE_BLOCK', class: 'state-success', order: 60 },
    ARCHIVED: { code: COMMON_STATE.ARCHIVED, class: 'state-archived', order: 70 },
    DISCARDED: { code: 'DISCARDED', class: 'state-discarded', order: 80 },
    CANCELED: { code: 'CANCELED', class: 'state-canceled', order: 90 },
    IN_SHIPMENT: { code: 'IN_SHIPMENT', class: 'state-shipment', order: 100 },
    OUT_OF_LABORATORY: { code: 'OUT_OF_LABORATORY', class: 'state-out-of-laboratory', order: 110 }
}

class PortionState extends EntityState {
    protected get entityName(): string {
        return 'portion'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            const states = await commonStatusService.getPortionStates()
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(
                    merge(
                        keyBy(states, 'code'),
                        keyBy(PORTION_STATES, 'code')))
            }
            await store.dispatch('setEntityState', entityState)
        }
    }
}

export const portionState = new PortionState()
